import { render, staticRenderFns } from "./ThankYouMessage.vue?vue&type=template&id=8b8860b8&scoped=true&"
import script from "./ThankYouMessage.vue?vue&type=script&lang=js&"
export * from "./ThankYouMessage.vue?vue&type=script&lang=js&"
import style0 from "./ThankYouMessage.vue?vue&type=style&index=0&id=8b8860b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8860b8",
  null
  
)

export default component.exports